import React from 'react';

import { useClassnames } from '@lumapps/classnames';
import { GridColumn, GridColumnProps, Size, Theme, useTheme } from '@lumapps/lumx/react';
import type { ElementRender } from '@lumapps/wrex/types';

import { COLUMNS } from '../../../constants';
import type { ColumnsElement } from '../../../types';

import './index.scss';

export const CLASSNAME = 'wrex-content-columns';

/**
 * Container for columns
 */
export const Columns: ElementRender<ColumnsElement, HTMLDivElement, GridColumnProps> = (props) => {
    const { children, className, elementRef, element, ...forwardedProps } = props;
    const { block } = useClassnames(CLASSNAME);
    const theme = useTheme() || Theme.light;
    const numberOfColumns = element?.children.length;

    return (
        <GridColumn
            {...forwardedProps}
            data-columns={numberOfColumns || 2}
            gap={Size.huge}
            // we set itemMinWidth to 20 so in translation manager we can still display 4 columns on preview
            itemMinWidth={20}
            maxColumns={numberOfColumns || 2}
            className={block({ [`theme-${theme}`]: true }, [className])}
            ref={elementRef}
        >
            {children}
        </GridColumn>
    );
};

Columns.displayName = COLUMNS;
